import { MessageApi } from 'api-typings/messages/messages_types';
import { transformTextEntity } from '../feed-posts/feed-posts.transformers';
import { Comment } from './comments.model';

export function transformComment(comment: MessageApi): Comment {
  return {
    id: comment.id,
    fromUser: comment.from_user,
    comment: comment.message,
    parentId: comment.parent_id ? comment.parent_id : undefined,
    threadId: comment.thread_id,
    timeCreated: comment.time_created * 1000,
    textEntities: comment.text_entities?.map(transformTextEntity),
  };
}
